import { useEffect, useContext } from "react";
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from "react-icons/fa";
import "../styles/ContactCard.css";

import { LanguageContext } from "../components/LanguageContext";
import { translations } from "../locales/contact";

export default function ContactCard() {
    // Берём текущий язык из контекста
    const { language } = useContext(LanguageContext);
    const t = translations[language];

    useEffect(() => {
        document.body.classList.add("modal-open");
        return () => {
            document.body.classList.remove("modal-open");
        };
    }, []);

    return (
        <div className="contact-card-overlay">
            <div className="contact-card">
                <h2 className="contact-title">{t.contactTitle}</h2>
                <div className="contact-info">
                    <div>
                        <p className="label">
                            <FaMapMarkerAlt style={{ marginRight: "8px" }} />
                            {t.addressLabel}
                        </p>
                        <p>
                            <a
                                href="https://yandex.com/maps/10309/bishkek/house/Y00Ycw9jQUICQFpofXR1dnxmYw==/?ll=74.583900%2C42.847082&z=19.71"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contact-link"
                            >
                                {t.addressValue}
                            </a>
                        </p>
                    </div>
                    <div>
                        <p className="label">
                            <FaPhone style={{ marginRight: "8px" }} />
                            {t.phoneLabel}
                        </p>
                        <p>
                            <a href="tel:+996880147014" className="contact-link">
                                {t.phoneValue}
                            </a>
                        </p>
                    </div>
                    <div>
                        <p className="label">
                            <FaEnvelope style={{ marginRight: "8px" }} />
                            {t.emailLabel}
                        </p>
                        <p>
                            <a href="mailto:unipaytechnology@gmail.com" className="contact-link">
                                {t.emailValue}
                            </a>
                        </p>
                    </div>
                    <div>
                        <p className="label">
                            <FaClock style={{ marginRight: "8px" }} />
                            {t.workTimeLabel}
                        </p>
                        <p>{t.workTimeValue}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
